var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.alt,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    },
                    {
                        text: _vm.currentPage.images.oImage1.text,
                        position: 'bottom-left', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-allports',
                    to: 'to-resolution_blue',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-allports',
                        to: 'to-resolution_blue',
                    }}},[_c('p',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleOne.text)}})]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"q10__article_container__content__paragraphs"},[_vm._l((_vm.currentPage
                                .content.sParagraphOne_Content.text),function(paragraph,idx_paragraph){return [(idx_paragraph === 0)?[_c('paragraph-first-letter-big',{staticClass:"relative -left-1",attrs:{"options":{
                                        letter: paragraph.substr(0, 1),
                                        color: 'text-allports',
                                    }}}),_c('paragraph',{attrs:{"options":{}}},[_c('span',{domProps:{"innerHTML":_vm._s(paragraph.slice(1))}})])]:_vm._e()]})],2)]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"break-inside-avoid"},[_c('div',[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                            icon: 'diaporama',
                                            collection: _vm.getRichmediaByCollection(
                                                _vm.currentPage,
                                                'Remerciements DPN'
                                            ),
                                        }}})],1),_c('image-with-descriptions',{staticClass:"eliminate-margin",attrs:{"options":{
                                    image:
                                        'pages/' +
                                        _vm.currentPage.slug +
                                        '/' +
                                        _vm.currentPage.images.oImage2.src,
                                    descriptions: [
                                        {
                                            text: _vm.currentPage.images.oImage2
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        } ],
                                }}})],1),_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-resolution_blue',
                                to: 'to-allports',
                            }}},[_c('Triangles',{attrs:{"options":{
                                    colors: [
                                        '#0e498a',
                                        '#064e8d',
                                        '#0264a7' ],
                                    direction: 'top',
                                }}}),_c('span',{staticClass:"font-bold",domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content.sParagraphTwo_Title
                                        .text
                                )}})],1)],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphTwo_Content.text
                        )}})]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"break-inside-avoid"},[_c('image-with-descriptions',{staticClass:"eliminate-margin",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage3.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage3
                                            .alt,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage3
                                            .text,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}}),_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-resolution_blue',
                                to: 'to-allports',
                            }}},[_c('Triangles',{attrs:{"options":{
                                    colors: [
                                        '#0e498a',
                                        '#064e8d',
                                        '#0264a7' ],
                                    direction: 'top',
                                }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content
                                        .sParagraphThree_Title.text
                                )}})],1)],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Content
                                    .text
                            )}}),_c('Dots',{attrs:{"options":{
                                colors: ['#0e498a', '#064e8d', '#0264a7'],
                            }}})],1)],1)],1),_c('div',{staticClass:"card relative mb-4 lg:mb-8"},[_c('div',{staticClass:"relative w-full h-full"},[_c('image-with-descriptions',{attrs:{"options":{
                            imageFullWidth:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage4.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage4.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"absolute top-0 right-0 p-10 px-16"},[_c('paragraph',{staticClass:"pl-3 md:text-3xl font-bold",attrs:{"options":{
                            color: 'text-white',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleTwo.text)}})])],1),_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Barrage de Petit-Saut (Guyane)-Abaissement et renforcement du seuil oxygénant'
                                ),
                            }}})],1),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-resolution_blue',
                            to: 'to-allports',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#0e498a', '#064e8d', '#0264a7'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Title
                                    .text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Content
                                    .text
                            )}}),_c('Dots',{attrs:{"options":{
                                colors: ['#0e498a', '#064e8d', '#0264a7'],
                            }}})],1)],1),_c('div',{staticClass:"card relative"},[_c('hotspot-richmedia',{staticClass:"top-0 right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Chantier de Petit-Saut en Guyane, témoignage de Claire Perot'
                            ),
                        }}}),_c('article-note',{staticStyle:{"margin-top":"0","margin-bottom":"1.25rem","overflow":"initial"},attrs:{"options":{
                            verticalcontent:
                                _vm.currentPage.content.sParagraphFive_Title
                                    .text,
                            content:
                                _vm.currentPage.content.sParagraphFive_Quote
                                    .text,
                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl xl:text-2xl',
                                content: '',
                            },
                            margin: {},
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage5.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage5.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1)]),_c('div',{staticClass:"card relative mb-4 lg:mb-8"},[_c('image-with-descriptions',{attrs:{"options":{
                        imageFullWidth:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.oImage6.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.oImage6.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.oImage6.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}}),_c('div',{staticClass:"\n                        absolute\n                        top-0\n                        left-0\n                        w-full\n                        xl:w-1/2\n                        p-5\n                        2xl:p-14\n                    "},[_c('paragraph',{staticClass:"pl-5 pt-7 md:text-3xl font-bold",attrs:{"options":{
                            color: 'text-white',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleThree.text)}})]),_c('TimelineTitle',{staticClass:"text-sm xl:text-lg",attrs:{"options":{
                            title: _vm.currentPage.content.sParagraphSix_Title
                                .text,
                            content:
                                _vm.currentPage.content.sParagraphSix_Content
                                    .text,
                            fontSize: {
                                title: 'text-base xl:text-lg',
                                content: 'text-md md:text-base lg:text-lg',
                            },
                            color: {
                                title: 'text-white',
                                content: 'text-white',
                            },
                        }}})],1)],1),_c('div',{staticClass:"card relative mb-4 lg:mb-8"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"bottom-2 left-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        'Une centrale électrique sous la Mer de glace à Chamonix'
                                    ),
                                }}}),_c('image-with-descriptions',{attrs:{"options":{
                            imageFullWidth:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage7.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage7.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"\n                        absolute\n                        top-0\n                        left-0\n                        w-full\n                        xl:w-1/2\n                        p-5\n                        2xl:p-14\n                    "},[_c('paragraph',{staticClass:"pl-5 md:text-3xl font-bold",attrs:{"options":{
                            color: 'text-white',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSeven_Title
                                    .text
                            )}})]),_c('TimelineTitle',{staticClass:"text-sm xl:text-lg",attrs:{"options":{
                            content:
                                _vm.currentPage.content.sParagraphSeven_Content
                                    .text,
                            fontSize: {
                                content: 'text-md md:text-base lg:text-lg',
                            },
                            color: {
                                content: 'text-white',
                            },
                        }}})],1)]),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-allports',
                            to: 'to-resolution_blue',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#0e498a', '#064e8d', '#0264a7'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphEight_Title
                                    .text
                            )}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphEight_Content.text
                        )}})],1),_c('div',{staticClass:"card"},[_c('article-note',{staticStyle:{"margin":"0"},attrs:{"options":{
                            verticalcontent:
                                _vm.currentPage.content.sParagraphNine_Title
                                    .text,
                            content:
                                _vm.currentPage.content.sParagraphNine_Quote
                                    .text,
                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-4xl lg:text-3xl',
                                content: '',
                            },
                            margin: {},
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage8.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage8.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}}),_c('hotspot-richmedia',{staticClass:"\n                            top-8\n                            right-2\n                        ",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                "Aménagement Des Bois (Chamonix) - Captage sous glaciaire"
                            ),
                        }}})],1),_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative break-inside-avoid"},[_c('image-with-descriptions',{staticClass:"mb-4 mt-0 lg:mb-8",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage9.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage9
                                            .alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                     {
                                        text: _vm.currentPage.images.oImage9
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}}),_c('hotspot-richmedia',{staticClass:"top-2 right-16",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Le réseau “Lacs sentinelles”'
                                ),
                            }}}),_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Emissions RCF -  Lacs Sentinelles'
                                ),
                            }}}),_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-resolution_blue',
                                to: 'to-allports',
                            }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content.sParagraphTen_Title
                                        .text
                                )}}),_c('Triangles',{attrs:{"options":{
                                    colors: [
                                        '#0e498a',
                                        '#064e8d',
                                        '#0264a7' ],
                                    direction: 'top',
                                }}})],1)],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTen_Content
                                    .text
                            )}})])],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }